module.exports = __webpack_public_path__ + "img/hakuna_step01.fb59b404.png";